import { useReduxState } from 'hooks';
import { Link } from 'components/common';

const TwoFactorApps = () => {
  const { theme } = useReduxState();

  return (
    <div className="apps">
      <ul>
        <li>
          {'Google Authenticator'}
          {' ('}
          <Link
            external={true}
            href="https://apps.apple.com/us/app/google-authenticator/id388497605"
            openInNewTab={true}
            text="iPhone"
          />
          {' / '}
          <Link
            external={true}
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2"
            openInNewTab={true}
            text="Android"
          />
          {' )'}
        </li>
        <li>
          {'Microsoft Authenticator'}
          {' ('}
          <Link
            external={true}
            href="https://apps.apple.com/us/app/microsoft-authenticator/id983156458"
            openInNewTab={true}
            text="iPhone"
          />
          {' / '}
          <Link
            external={true}
            href="https://play.google.com/store/apps/details?id=com.azure.authenticator"
            openInNewTab={true}
            text="Android"
          />
          {' )'}
        </li>
      </ul>

      <style jsx>{`
        .apps {
          color: ${theme.textColorLight};
          font-size: 1.5rem;
          font-weight: 400;
        }
        .apps ul {
          margin: 10px 0;
          padding-left: 30px;
        }
        .apps li {
          font-weight: 600;
          padding: 2px 0;
        }
      `}</style>
    </div>
  );
};

export default TwoFactorApps;
